import App from "../../App";

const Clipboard = {

    init() {

        /*this.el = $('[component="Clipboard"]');

        if (!this.el.length) {
            return;
        }*/

        this.start();
        this.bind();
    },

    start() {
        Clipboard.create();
    },

    bind() {
        $(document).on('mouseenter mouseleave click', '.ctc', function (e) {

            let button = $(this).data('ctc-button');

            let clipboardButton  = $('.b' + button);
            let parent = clipboardButton.parent().parent();
            let clipboardParent = clipboardButton.parents('[component="Clipboard"]');

            /*if ( $(this).attr( 'data-ctcspecial') ) {

                var $S_TARGET = $(this).attr('data-ctcspecialtarget');

                switch( $(this).data('ctcspecial') ) {

                    case 1:
                    case 2:
                    case 3:
                        var $data = [];
                        $( $(this).data('ctcspecialtarget') ).each( function (ii,ee) {

                            $data[ii] = $(this).data('id');
                        });

                        //$(this).removeAttr( 'data-ctc-value' );
                        $(this).data( 'ctc-value', Clipboard.create_ctcdata( $(this), $data ) );
                        break;

                    case 10: //product description
                        $(this).data( 'ctc-value', $( '#additem__description').html() );

                        break;

                    case 11: //product description text
                        $(this).data( 'ctc-value', $( '#additem__description').text() );

                        break;

                    case 15: //target content
                        var $INP = $( $(this).parents().closest('.addi-select, .addi-input') ).find('select, input, textarea'),
                            $VALO = null;

                        if ( $INP.is('select') )
                            $VALO = $INP.find('option:selected').text();
                        else
                            $VALO = $INP.val();


                        $(this).data( 'ctc-value', $VALO );
                        break;
                }
            }*/

            /*if ($(this).find('.copyToClipboard').length === 0) {
                let r_class = Clipboard.random_class_($(this));

                if (!$(this).attr('data-ctc-value')) {
                    $(this).attr('data-ctc-value', $(this).text());
                }

                $(this).attr('data-ctc-button', r_class);

                if ($(this).hasClass('ctcrow'))
                    $(this).append('<button type="button" class="copyToClipboard b' + r_class + '" data-ctc=".' + r_class + '">KOPÍROVAŤ RIADOK</button>');
                else
                    $(this).append('<button type="button" class="copyToClipboard b' + r_class + '" data-ctc=".' + r_class + '">KOPÍROVAŤ</button>');
            }*/

            let parentPosLeft = parent[0].offsetLeft + $('nav[element="menu"]').width();
            let clipboardWidth = 150;

            switch (e.type) {
                case 'mouseenter':

                    if ( (parentPosLeft + parent.outerWidth() + clipboardWidth) >  window.outerWidth ) {
                        clipboardParent.css({"left": "auto", "right": "100%"});
                    }

                    clipboardParent.css('display', 'inline-block');
                    break;

                case 'mouseleave':
                    clipboardParent.css('display', 'none');
                    break;
            }
        })

        $(document).on("click", '.copyToClipboard', function () {

            let target = $(this).data('ctc');

            if ($(this).parent().hasClass('ctcrow')) {
                $('.highlight02').removeClass('highlight02').text('KOPÍROVAŤ RIADOK');
            } else {
                $('.highlight02').removeClass('highlight02').text('KOPÍROVAŤ');
            }

            $(this).addClass('highlight02').text('SKOPÍROVANÉ');

            Clipboard.copyToClipboard(target);
        });
    },

    create() {
        $('.ctc, .ctcp').each(function (i) {
            let r_class = Clipboard.random_class_($(this));
            let clipboardText = 'KOPÍROVAŤ';
            let value = $(this).text();

            if (!$(this).attr('data-ctc-value')) {
                let ctcValue = App.isJson(value) ? JSON.stringify(value) : value;

                $(this).attr('data-ctc-value', ctcValue);
            }

            $(this).attr('data-ctc-button', r_class);

            if ($(this).hasClass('ctcrow')) {
                clipboardText = 'KOPÍROVAŤ RIADOK';
            }

            $(this).append('<div component="Clipboard"><button type="button" class="copyToClipboard b' + r_class + '" data-ctc=".' + r_class + '">' + clipboardText + '</button></div>');
        });
    },

    create_ctcdata($this, data) {
        if (data) {

            var d = '';

            d += $this.data('fixbefore') ? $this.data('fixbefore') : null;
            d += data.join('#');

            return d;
        }
    },

    random_class_(target) {
        let $d_class = $(target).attr('class'),
            $random = Clipboard.random_chars_(10);

        $(target).attr('class', $d_class + ' ' + $random);

        return $random;
    },

    random_chars_($pocet_znakov, $improved = false, $improved_d = '_*/?!') {
        let $default = "abcdefghijklmopqrstuvwxyz01234567890123456789012345678901234567890";

        let $skupina_znakov = $improved ? $default.$improved_d.mb_strtoupper($default) : $default;
        let $return = "";
        let $pocet_znaku = ($skupina_znakov).length - 1;

        for (let $i = 0; $i < $pocet_znakov; $i++) {
            $return += $skupina_znakov[Math.floor((Math.random() * $pocet_znaku) + 1)];
        }

        return $return;
    },

    copyToClipboard(element) {

        let $temp = $("<textarea>");
        $("body").append($temp);

        let value = $temp.val($(element).data('ctc-value')).val();

        let ctcValue = App.isJson(value) ? JSON.parse(value) : value;

        $temp.val(ctcValue).select();

        document.execCommand("copy");
        $temp.remove();
    }
}
export default Clipboard;